
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jtTPi", function(module, exports) {

$parcel$export(module.exports, "CreateCommitDropdown", () => $cbe0ac326857dcf7$export$6abc9e0bd1890013);
$parcel$export(module.exports, "default", () => $cbe0ac326857dcf7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $aI3Yr = parcelRequire("aI3Yr");

var $4ykog = parcelRequire("4ykog");

var $kCfLv = parcelRequire("kCfLv");
const $cbe0ac326857dcf7$var$ONBOARDING_LINK = 'https://support.atlassian.com/jira-software-cloud/docs/reference-issues-in-your-development-work/';
const $cbe0ac326857dcf7$var$LearnMoreLink = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        target: "_blank",
        spacing: "none",
        testId: "development-summary-commit.ui.create-commit-dropdown.button-learn-more",
        href: $cbe0ac326857dcf7$var$ONBOARDING_LINK,
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createCommitLearnMore');
        }
    }, children);
const $cbe0ac326857dcf7$export$6abc9e0bd1890013 = ({ onOpenDropdown: onOpenDropdown, getDropdownTrigger: getDropdownTrigger })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const previousOpen = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (previousOpen.current !== isOpen) {
            previousOpen.current = isOpen;
            isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown opened', 'commitCreateDropdown');
            !isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown closed', 'commitCreateDropdown');
            onOpenDropdown && onOpenDropdown({
                isOpen: isOpen
            });
        }
    }, [
        createAnalyticsEvent,
        isOpen,
        onOpenDropdown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        id: "create-commit-dropdown",
        testId: "development-summary-commit.ui.create-commit-dropdown.popup",
        zIndex: (0, $gwIPs.layers).modal + 1,
        placement: "bottom-end",
        messageId: "development-summary-commit.ui.create-commit-dropdown.popup",
        messageType: "transactional",
        shouldFlip: true,
        trigger: (triggerProps)=>getDropdownTrigger({
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen)
            }),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cbe0ac326857dcf7$var$CommitDropdownWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
                title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $kCfLv.default).commitOnboardingGroupTitleIssueTermRefresh : (0, $kCfLv.default).commitOnboardingGroupTitle)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cbe0ac326857dcf7$var$CustomDropdownItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
                componentsMapping: {
                    link: $cbe0ac326857dcf7$var$LearnMoreLink
                },
                message: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $kCfLv.default).commitOnboardingGroupMessageIssueTermRefresh : (0, $kCfLv.default).commitOnboardingGroupMessage, {
                    linkStart: '{linkStart}',
                    linkEnd: '{linkEnd}'
                })
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ykog.CopyIssueKey), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aI3Yr.CopyCommitCommand), null)))))
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cbe0ac326857dcf7$var$CustomDropdownItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f3v47k _n3tdu2gc _19bvv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cbe0ac326857dcf7$var$CommitDropdownWidthContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12frdnh",
            __cmplp.className
        ])
    });
});
var $cbe0ac326857dcf7$export$2e2bcd8739ae039 = $cbe0ac326857dcf7$export$6abc9e0bd1890013;

});
parcelRegister("aI3Yr", function(module, exports) {

$parcel$export(module.exports, "CopyCommitCommand", () => $a4fc545f5cf0d8fb$export$70b0e60575091ff4);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $jKHSj = parcelRequire("jKHSj");

var $8zOmE = parcelRequire("8zOmE");

var $2SF45 = parcelRequire("2SF45");
const $a4fc545f5cf0d8fb$export$469f5ff4aab5321b = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    return `git commit -m "${issueKey} <message>"`;
};
const $a4fc545f5cf0d8fb$export$70b0e60575091ff4 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const suggestedCommitMessage = $a4fc545f5cf0d8fb$export$469f5ff4aab5321b();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKHSj.CopyTextFieldWithLabel), {
        label: formatMessage((0, $2SF45.default).copyGitCommitLabel),
        name: "copy-git-commit",
        id: "copy-git-commit",
        value: suggestedCommitMessage,
        onCopyClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createCommitCommandCopyButton');
        }
    }));
};
var $a4fc545f5cf0d8fb$export$2e2bcd8739ae039 = $a4fc545f5cf0d8fb$export$70b0e60575091ff4;

});
parcelRegister("jKHSj", function(module, exports) {

$parcel$export(module.exports, "CopyTextField", () => $0cd75fd9edf283c3$export$90c50f13f5e8c8e3);
$parcel$export(module.exports, "CopyTextFieldWithLabel", () => $0cd75fd9edf283c3$export$e18e72b7cc9c2f26);

var $47bDC = parcelRequire("47bDC");

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");

var $3Fq5M = parcelRequire("3Fq5M");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $7EEmi = parcelRequire("7EEmi");

var $koVbs = parcelRequire("koVbs");

var $3FVmC = parcelRequire("3FVmC");

var $fPIhN = parcelRequire("fPIhN");
const $0cd75fd9edf283c3$var$handleTextFieldClick = ({ target: target })=>{
    // Selects the full contents of the input for single clicks. This check
    // preserves default click & drag functionality when selecting a portion of text.
    const { selectionStart: selectionStart, selectionEnd: selectionEnd, value: value } = target;
    if (selectionStart === selectionEnd || selectionStart === 0 && selectionEnd === value.length) target.select();
};
// Exporting for test purposes
var $0cd75fd9edf283c3$var$_StyledDiv = /*#__PURE__*/ (0, $47bDC.default)("div")`${(0, $fPIhN.copyTextFieldWrapperStyles)}`;
var $0cd75fd9edf283c3$var$_StyledDiv2 = /*#__PURE__*/ (0, $47bDC.default)("div").withConfig({
    componentId: "is2i2p-0"
})`${(0, $fPIhN.fieldWrapperStyles)}`;
const $0cd75fd9edf283c3$export$90c50f13f5e8c8e3 = ({ value: value, delay: delay = 100, onCopyClick: onCopyClick, id: id, 'aria-labelledby': ariaLabelledBy, 'aria-label': ariaLabel // used for testing purposes
 })=>{
    let tooltipLabel;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const inputRef = (0, $5uXOq.useRef)();
    const timeoutIdRef = (0, $5uXOq.useRef)();
    const [showCopiedTooltip, setShowCopiedTooltip] = (0, $5uXOq.useState)(false);
    const [copyFailed, setCopyFailed] = (0, $5uXOq.useState)(false);
    const handleCopyClick = (event, analyticsEvent)=>{
        onCopyClick && onCopyClick(event, analyticsEvent);
        setCopyFailed(false);
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        inputRef && inputRef.current && inputRef.current.select();
        let success = false;
        try {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            success = document.execCommand('copy');
            setShowCopiedTooltip(true);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            setCopyFailed(true);
            success = false;
        }
        if (!success) setShowCopiedTooltip(false);
        timeoutIdRef.current = setTimeout(()=>{
            setShowCopiedTooltip(false);
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(timeoutIdRef.current);
        }, 3000);
        event.currentTarget.focus();
    };
    const handleMouseLeave = ()=>{
        if (timeoutIdRef.current) {
            setShowCopiedTooltip(false);
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(timeoutIdRef.current);
        }
    };
    if (showCopiedTooltip === true) tooltipLabel = formatMessage((0, $3FVmC.default).copiedTooltipLabel);
    else if (copyFailed) tooltipLabel = formatMessage((0, $3FVmC.default).copyFailedTooltipLabel);
    return(// @ts-expect-error Property 'css' does not exist on type 'DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>'.ts(2322)
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd75fd9edf283c3$var$_StyledDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd75fd9edf283c3$var$_StyledDiv2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        id: id,
        testId: `platform-copy-text-field.textfield--${id || ''}`,
        "aria-labelledby": ariaLabelledBy,
        "aria-label": ariaLabel,
        ref: inputRef,
        value: value,
        // @ts-expect-error - TS2322 - Type '({ target }: ChangeEvent<HTMLInputElement>) => void' is not assignable to type 'MouseEventHandler<HTMLInputElement>'.
        onClick: $0cd75fd9edf283c3$var$handleTextFieldClick,
        onMouseDown: (e)=>{
            // This prevents the cursor from jumping to the end of the input onMouseDown
            // caused by Atlaskit's Textfield focusing the underlying input onMouseDown
            // @ts-expect-error - TS2339 - Property 'blur' does not exist on type 'EventTarget'.
            e.target.blur();
        },
        onMouseUp: (e)=>{
            // Prevents flaky behaviour where text is de-selected onMouseUp
            e.preventDefault();
        },
        isReadOnly: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        tag: "span",
        delay: delay,
        content: tooltipLabel || '',
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EEmi.StyledButton), {
        onClick: handleCopyClick,
        onMouseLeave: handleMouseLeave,
        testId: `platform-copy-text-field.styled-button-${id || ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
        spacing: "spacious",
        label: formatMessage((0, $3FVmC.default).copyIconLabel)
    })))));
};
const $0cd75fd9edf283c3$export$e18e72b7cc9c2f26 = ({ label: label, name: name, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: name,
        label: label
    }, ({ fieldProps: { id: id, 'aria-labelledby': ariaLabelledBy } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd75fd9edf283c3$export$90c50f13f5e8c8e3, {
            id: id,
            "aria-labelledby": ariaLabelledBy,
            ...props
        }));
var $0cd75fd9edf283c3$export$2e2bcd8739ae039 = $0cd75fd9edf283c3$export$90c50f13f5e8c8e3;

});
parcelRegister("3FVmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8af5908881f4a809$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8af5908881f4a809$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copiedTooltipLabel: {
        "id": "platform-copy-text-field.copied-tooltip-label",
        "defaultMessage": "Copied!"
    },
    copyFailedTooltipLabel: {
        "id": "platform-copy-text-field.copy-failed-tooltip-label",
        "defaultMessage": "Copy failed!"
    },
    copyIconLabel: {
        "id": "platform-copy-text-field.copy-icon-label",
        "defaultMessage": "Copy icon"
    }
});

});

parcelRegister("fPIhN", function(module, exports) {

$parcel$export(module.exports, "copyTextFieldWrapperStyles", () => $ab4ab7f43531db5a$export$9acbfd01fa817150);
$parcel$export(module.exports, "fieldWrapperStyles", () => $ab4ab7f43531db5a$export$540e61204cc9de4);

var $gwIPs = parcelRequire("gwIPs");
const $ab4ab7f43531db5a$export$9acbfd01fa817150 = `
    display: flex;
`;
const $ab4ab7f43531db5a$export$540e61204cc9de4 = `
    flex-grow: 1;
    margin-right: ${(0, $gwIPs.gridSize)}px;
    // Override blue focus ring and white background colour on focus
    [data-ds--text-field--container] {
        &:focus-within {
            border-color: ${"var(--ds-border, #091E4224)"};
        }
    }
    [data-ds--text-field--input] {
        &:focus {
            background: ${"var(--ds-border, #091E4224)"};
        }
    }
`;

});


parcelRegister("2SF45", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b5e580dfe239af4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9b5e580dfe239af4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyGitCommitLabel: {
        "id": "development-summary-commit.create-commit-dropdown.copy-commit-command.copy-git-commit-label",
        "defaultMessage": "Copy sample Git commit"
    }
});

});


parcelRegister("4ykog", function(module, exports) {

$parcel$export(module.exports, "CopyIssueKey", () => $81e21194aac2b1d6$export$17bece6c5afb2a24);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $jKHSj = parcelRequire("jKHSj");

var $8zOmE = parcelRequire("8zOmE");

var $k5OaI = parcelRequire("k5OaI");
const $81e21194aac2b1d6$export$17bece6c5afb2a24 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKHSj.CopyTextFieldWithLabel), {
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $k5OaI.default).copyIssueKeyLabelIssueTermRefresh : (0, $k5OaI.default).copyIssueKeyLabel),
        name: "copy-issue-key",
        id: "copy-issue-key",
        value: issueKey,
        onCopyClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createCommitIssueKeyCopyButton');
        }
    }));
};
var $81e21194aac2b1d6$export$2e2bcd8739ae039 = $81e21194aac2b1d6$export$17bece6c5afb2a24;

});
parcelRegister("k5OaI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a179e257e1b113b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1a179e257e1b113b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyIssueKeyLabel: {
        "id": "development-summary-commit.create-commit-dropdown.copy-issue-key.copy-issue-key-label",
        "defaultMessage": "Copy issue key"
    },
    copyIssueKeyLabelIssueTermRefresh: {
        "id": "development-summary-commit.create-commit-dropdown.copy-issue-key.copy-issue-key-label-issue-term-refresh",
        "defaultMessage": "Copy key"
    }
});

});


parcelRegister("kCfLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b793864da5bf01c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9b793864da5bf01c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    commitOnboardingGroupTitle: {
        "id": "development-summary-commit.create-commit-dropdown.commit-onboarding-group-title",
        "defaultMessage": "Link commits to Jira issues"
    },
    commitOnboardingGroupMessage: {
        "id": "development-summary-commit.create-commit-dropdown.commit-onboarding-group-message",
        "defaultMessage": "Include issue keys in your commit messages to link them to your Jira issues. {linkStart}Learn more{linkEnd}"
    },
    commitOnboardingGroupTitleIssueTermRefresh: {
        "id": "development-summary-commit.create-commit-dropdown.commit-onboarding-group-title-issue-term-refresh",
        "defaultMessage": "Link commits to Jira work items"
    },
    commitOnboardingGroupMessageIssueTermRefresh: {
        "id": "development-summary-commit.create-commit-dropdown.commit-onboarding-group-message-issue-term-refresh",
        "defaultMessage": "Include keys in your commit messages to link them to your Jira work items. {linkStart}Learn more{linkEnd}"
    }
});

});



//# sourceMappingURL=create-commit-dropdown.2c216f71.js.map
